import axios, { type AxiosInstance } from "axios"

/**
 * A client of its own, deliberately plain.
 *
 * The shared one attaches whatever login token is in storage and, on a 401,
 * logs the user out and sends them to /login. Both are wrong here: the caller
 * is a customer with no account, and a 401 on their signing link would throw
 * them into a login screen they can do nothing with.
 *
 * It carries no credentials, no interceptors and no redirects — just the
 * recipient's short-lived session header.
 */
const SESSION_HEADER = "X-Esign-Session"

export const signingClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_ROUTE,
  headers: { "Content-Type": "application/json" },
  // Anything but 5xx is an answer this page knows how to render: a refusal has
  // a reason, and a wrong code has attempts left.
  validateStatus: (status: number) => status < 500
})

export const withSession = (session: string | null) =>
  session ? { headers: { [SESSION_HEADER]: session } } : {}
